
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-profile/account-settings",
      function () {
        return require("private-next-pages/my-profile/account-settings/index.tsx");
      }
    ]);
  